import logo2006 from "../../assets/img/historicEvents/LogoCyberSunday/2006.png";
import logo2007 from "../../assets/img/historicEvents/LogoCyberSunday/2007.png";
import logo2008 from "../../assets/img/historicEvents/LogoCyberSunday/2008.png";

export const cyberSundayDetail = {
  "cyber-sunday": {
    id: "cyber-sunday",
    title: "Cyber Sunday",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "cyber-sunday",
        items: [
          {
            id: "cyber-sunday-2006",
            title: "Cyber Sunday",
            description: "Log on. Take over. 2006",
            imgUrl: logo2006,
          },
          {
            id: "cyber-sunday-2007",
            title: "Cyber Sunday",
            description: "Log on. Take over. 2007",
            imgUrl: logo2007,
          },
          {
            id: "cyber-sunday-2008",
            title: "Cyber Sunday",
            description: "2008",
            imgUrl: logo2008,
          },
        ],
      },
    ],
  },
};
